import React from "react";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as Yup from "yup";

import { useFormik } from "formik";
import TravelLinkService from "../../../../../services/TravelLinkService/TravelLinkService";
import toast from "react-hot-toast";

const BookModalForm = ({ toggle, modal }) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      nationality: "",
      email: "",
      phone: "",
      arrival_date: "",
      departure_date: "",
      no_of_people: "",
      special_requirement: "",
      address: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Full name is required"),
      nationality: Yup.string().required("Nationality is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      arrival_date: Yup.string().required("Arrival Date is required"),
      departure_date: Yup.string().required("Departure Date is required"),
      phone: Yup.string().required("Contact number is required"),
      address: Yup.string().required("Address is required"),

      no_of_people: Yup.string().required("No of people is required"),
      special_requirement: Yup.string(),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await TravelLinkService.saveBooking(values);
        toast.success("Package is booked successfully.");
        resetForm(); // Clear the form here
        toggle();
      } catch (error) {
        console.log(error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred";
        toast.error(errorMessage);
      }
    },
  });
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Book the trip</ModalHeader>
        <ModalBody>
          <form onSubmit={formik.handleSubmit}>
            <h6 className="mb-2">Fill out the form below to book this trip.</h6>
            <Row>
              <Col md={12} className="mb-2">
                <Label for="name">Enter the full name</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter the full name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-danger">{formik.errors.name}</div>
                ) : null}
              </Col>
              <Col md={6} className="mb-2">
                <Label for="address">Address</Label>
                <Input
                  type="text"
                  id="address"
                  name="address"
                  placeholder="Enter address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                />
                {formik.touched.address && formik.errors.address ? (
                  <div className="text-danger">{formik.errors.address}</div>
                ) : null}
              </Col>
              <Col md={6} className="mb-2">
                <Label for="nationality">Nationality</Label>
                <Input
                  type="text"
                  id="nationality"
                  name="nationality"
                  placeholder="Enter nationality"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nationality}
                />
                {formik.touched.nationality && formik.errors.nationality ? (
                  <div className="text-danger">{formik.errors.nationality}</div>
                ) : null}
              </Col>

              <Col md={6} className="mb-2">
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter the email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-danger">{formik.errors.email}</div>
                ) : null}
              </Col>

              <Col md={6} className="mb-2">
                <Label for="phone">Contact Number</Label>
                <Input
                  type="text"
                  id="phone"
                  name="phone"
                  placeholder="Contact Number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <div className="text-danger">{formik.errors.phone}</div>
                ) : null}
              </Col>

              <Col md={6} className="mb-2">
                <Label for="arrival_date">Arrival Date</Label>
                <Input
                  type="date"
                  id="arrival_date"
                  name="arrival_date"
                  placeholder="Arrival Date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.arrival_date}
                />
                {formik.touched.arrival_date && formik.errors.arrival_date ? (
                  <div className="text-danger">
                    {formik.errors.arrival_date}
                  </div>
                ) : null}
              </Col>
              <Col md={6} className="mb-2">
                <Label for="departure_date">Departure Date</Label>
                <Input
                  type="date"
                  id="departure_date"
                  name="departure_date"
                  placeholder="Departure Date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.departure_date}
                />
                {formik.touched.departure_date &&
                formik.errors.departure_date ? (
                  <div className="text-danger">
                    {formik.errors.departure_date}
                  </div>
                ) : null}
              </Col>
              <Col md={12} className="mb-2">
                <Label for="no_of_people">No of people</Label>
                <Input
                  type="number"
                  id="no_of_people"
                  name="no_of_people"
                  placeholder="Arrival Date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.no_of_people}
                />
                {formik.touched.no_of_people && formik.errors.no_of_people ? (
                  <div className="text-danger">
                    {formik.errors.no_of_people}
                  </div>
                ) : null}
              </Col>

              <Col md={12} className="mb-3">
                <Label for="special_requirement">Special Requirement</Label>
                <Input
                  type="textarea"
                  id="special_requirement"
                  name="special_requirement"
                  placeholder="Let us know all your inquires and we will get back to you shortly"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.special_requirement}
                />
                {formik.touched.special_requirement &&
                formik.errors.special_requirement ? (
                  <div className="text-danger">
                    {formik.errors.special_requirement}
                  </div>
                ) : null}
              </Col>
              <Col>
                <Button type="submit" color="info" className="w-25">
                  Submit
                </Button>
              </Col>
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default BookModalForm;
